import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { BackResponseFailure, Theme } from '@savgroup-front-common/types';
import { AuthConfiguration } from '@/configuration';

const getDefaultTheme = async (): Promise<Theme | BackResponseFailure> => {
  const ENDPOINT = `${AuthConfiguration.authority}/Style/Json?clientId=${AuthConfiguration.clientId}`;

  try {
    const response = await fetch(ENDPOINT, {
      method: SUPPORTED_METHODS.GET,
    });

    return await response.json();
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default getDefaultTheme;
